import { customStudyThemeList } from './customStudy/index';
import { systemStudyThemeList, systemThemeTypeMap } from './systemStudy/index';
import { enterpriseThemeList } from './enterprise/index';
import { ICertificateThemeProps } from './interface/common';
import { CERTIFICATE_TYPE } from './interface/index';
import '../style/index.scss';

const themeList: Record<CERTIFICATE_TYPE, ((props: ICertificateThemeProps) => JSX.Element)[]> = {
    [CERTIFICATE_TYPE.ENTERPRISE]: enterpriseThemeList,
    [CERTIFICATE_TYPE.SYSTEM_STUDY]: systemStudyThemeList,
    [CERTIFICATE_TYPE.CUSTOM_STUDY]: customStudyThemeList,
}

export {
    themeList,
    systemThemeTypeMap,
    customStudyThemeList,
    systemStudyThemeList,
    enterpriseThemeList
}
